import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {mapActions, mapState} from 'vuex'
import 'element-ui/lib/theme-chalk/index.css';
import {Tabs, TabPane, Message} from 'element-ui';

import VueClipboard from 'vue-clipboard2';
import LoadingV from './components/modal/loadingV';

Vue.use(VueClipboard);
Vue.component('LoadingV', LoadingV);
import pagination from './components/pagination'
Vue.component('Pagination', pagination);

Vue.config.productionTip = false;
import {requestConfig} from "./assets/js/config/host";

Vue.prototype.requestConfig = requestConfig;
Vue.prototype.$message = Message;
Vue.use(Tabs);
Vue.use(TabPane);

Vue.mixin({
    filters: {
        time2Date: function (timestamp) {
            let time = new Date(timestamp * 1000);
            let y = time.getFullYear();
            let m = time.getMonth() + 1;
            let d = time.getDate();
            let h = time.getHours();
            let mm = time.getMinutes();
            let s = time.getSeconds();
            return y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + s;
        },
        //格式化函数
        fmoney: function (s, n) {
            n = n > 0 && n <= 20 ? n : 2;
            s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
            let l = s.split(".")[0].split("").reverse();
            let t = "";
            for (let i = 0; i < l.length; i++) {
                t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
            }
            return t.split("").reverse().join("");
        },
        roundOff(num, digit) {
            num = Number(num)
            let m = 10 ** digit;
            return (parseFloat(num * m) / m).toFixed(digit);
            // if (!digit) digit = 0;
            // return new BigNumber(num).toFixed(digit);
            // if (!digit) digit = 0;
            // let res = Math.floor(num * 10 ** digit) / 10 ** digit;
            // let res = this.toBigNumber(num).multipliedBy(10 ** digit).dividedBy(10 ** digit);
            // return new BigNumber(num).multipliedBy(10 ** digit).dividedBy(10 ** digit).toFixed(digit);
        },
    },
    computed: {
        ...mapState("modal", [
            "loadingV"
        ]),
    },
    methods: {
        changeRoute(newRoute, routeQuery = {}, blank = false) {
            if (!blank) {
                router.push({path: newRoute, query: routeQuery});
            } else {
                let routeUrl = router.resolve({
                    path: newRoute,
                    query: routeQuery
                });
                window.open(routeUrl.href, '_blank');
            }
        },
        addressSub(address = '', length = 10) {
            return address.substring(0, length) + "..." + address.substring(address.length - length, address.length);
        },
        ...mapActions('modal', [
            'aLoadingV'
        ]),
    }
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
